import { useState } from 'react'
import { message } from 'antd'
import { CountTime } from 'src/components'
import { $api } from 'src/plugins'

const SMSCode = (props: { phone: string }) => {
  const [counting, setCounting] = useState(false)

  const handleSendCode = () => {
    setCounting(true)
    $api['common/getVerifyCode']({
      phone: props.phone
    }).then(res => {
      if (res) {
        message.success('发送成功')
      } else {
        message.error('发送失败，请重试')
        setCounting(false)
      }
    }).catch(() => {
      message.error('发送失败，请重试')
      setCounting(false)
    })
  }

  return (
    <div className='login-smscode'>
      {
        counting
          ? (
            <CountTime
              seconds={59}
              format={(h, m, s) => `${s}`}
              onCountDone={() => setCounting(false)}
              extraFont='验证码已发送('
              addonFont=')'
              className='doing'
            />
          )
          : <span onClick={handleSendCode} className='ready'>发送验证码</span>
      }
    </div>
  )
}

export default SMSCode